export function cleanTaxaName(name: string | undefined | null): string {
  if (name == null) {
    return "";
  }
  return name.replace("[", "").replace("]", "");
}
